<template>
  <div style="padding: 0 20px 20px">
    <div style="margin-bottom: 12px">
      <el-button type="primary" icon="el-icon-plus" @click="openAddPersons">添加老人</el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" border style="width: 100%" size="small">
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column label="老人姓名" min-width="90" align="center">
        <template slot-scope="scope"><span>{{ scope.row.person_name }}</span></template>
      </el-table-column>
      <el-table-column label="服务开始日期" min-width="110" align="center">
        <template slot-scope="scope"><span>{{ scope.row.start_date }}</span></template>
      </el-table-column>
      <el-table-column label="下次服务时间" min-width="150" align="center">
        <template slot-scope="scope"><span>{{ scope.row.next_time }}</span></template>
      </el-table-column>
      <el-table-column label="服务进度" width="160" align="center">
        <template slot-scope="scope">
          <div style="padding:0 6px">
            <el-progress :percentage="getProgressPct(scope.row)"
                         :format="() => `${scope.row.generated_count}/${scope.row.total_count}`"
                         :status="scope.row.generated_count >= scope.row.total_count ? 'success' : ''">
            </el-progress>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否在世" width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_dead === 0" type="success" size="mini">在世</el-tag>
          <el-tag v-else-if="scope.row.is_dead === 1" type="danger" size="mini">离世</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.generated_count < scope.row.total_count" type="success" size="mini">进行中</el-tag>
          <el-tag v-else type="info" size="mini">已完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="170">
        <template slot-scope="scope">
          <el-button v-if="scope.row.generated_count < scope.row.total_count" size="mini" type="danger"
                     @click="removePersonRow(scope.row)">移除</el-button>
          <el-button v-if="scope.row.generated_count >= scope.row.total_count" size="mini" type="primary"
                     @click="openRenew(scope.row)">续期</el-button>
          <el-button size="mini" type="info" @click="viewOrders(scope.row)">服务单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;text-align:center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50]"
                     :page-size="pageSize" layout="total, sizes, prev, pager, next" :total="totalCells">
      </el-pagination>
    </div>

    <!-- 添加老人子对话框 -->
    <el-dialog :visible.sync="addPersonShow" v-if="addPersonShow" width="860px"
               :show-close="true" :close-on-click-modal="false" append-to-body center class="all-open">
      <div class="title-top-alarm">
        <div><strong>添加老人</strong></div>
        <div class="line-title"></div>
      </div>
      <div style="padding: 0 20px 20px">
        <el-form label-width="110px">
          <el-form-item label="服务开始日期">
            <el-date-picker v-fixZoom v-model="addForm.start_date" type="date"
                            value-format="yyyy-MM-dd" placeholder="第一次生成服务单日期（留空=今天）"
                            style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="按组织查询">
            <el-cascader v-fixZoom v-model="orgSearchId" :options="orgTree" :props="orgCascaderProps"
                         filterable clearable placeholder="选择组织自动加载老人列表" style="width:100%"
                         @change="searchPersonsByOrg" :loading="searchLoading"></el-cascader>
          </el-form-item>
          <el-form-item label="按姓名搜索">
            <div style="display:flex;gap:8px">
              <el-input v-model="personSearch" placeholder="输入老人姓名搜索" style="flex:1"
                        @keyup.enter.native="searchPersons"></el-input>
              <el-button type="primary" @click="searchPersons" :loading="searchLoading">搜索</el-button>
            </div>
          </el-form-item>
          <el-form-item label=" " v-if="personResults.length > 0">
            <div style="margin-bottom:6px;display:flex;justify-content:flex-end;gap:8px">
              <el-button size="mini" type="primary" plain @click="selectAllPersons">全选</el-button>
              <el-button size="mini" plain @click="clearAllPersons">取消全选</el-button>
            </div>
            <el-table :data="personResults" size="mini" border max-height="300" style="width:100%">
              <el-table-column prop="name" label="姓名" min-width="70" align="center"></el-table-column>
              <el-table-column label="性别" width="55" align="center">
                <template slot-scope="scope">
                  <span>{{ util.getSex(scope.row.sex + '') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="电话" min-width="110" align="center"></el-table-column>
              <el-table-column prop="id_number" label="身份证号" min-width="160" align="center"></el-table-column>
              <el-table-column prop="h_address" label="地址" min-width="120" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" width="70" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="addPersonToList(scope.row)"
                             :disabled="isPersonAdded(scope.row)">添加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="已选老人" v-if="selectedPersons.length > 0">
            <el-tag v-for="(p, idx) in selectedPersons" :key="p.id" closable
                    @close="removeFromSelected(idx)" style="margin:2px 4px 2px 0">{{ p.name }}</el-tag>
          </el-form-item>
        </el-form>
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="addPersonShow = false"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddPersons"><span>确定</span></div>
          </el-col>
        </el-row>
        <div style="height: 20px"></div>
      </div>
    </el-dialog>

    <!-- 续期子对话框 -->
    <el-dialog :visible.sync="renewShow" v-if="renewShow" width="480px"
               :show-close="true" :close-on-click-modal="false" append-to-body center class="all-open">
      <div class="title-top-alarm">
        <div><strong>服务包续期</strong></div>
        <div class="line-title"></div>
      </div>
      <div style="padding: 0 20px 20px">
        <el-form label-width="120px">
          <el-form-item label="老人姓名">
            <span>{{ renewRow.person_name }}</span>
          </el-form-item>
          <el-form-item label="已完成次数">
            <span>{{ renewRow.generated_count }} / {{ renewRow.total_count }}</span>
          </el-form-item>
          <el-form-item label="续期起始日期">
            <el-date-picker v-fixZoom v-model="renewDate" type="date" value-format="yyyy-MM-dd"
                            placeholder="续期起始日期（留空=今天）" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-form>
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="renewShow = false"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitRenew"><span>确定</span></div>
          </el-col>
        </el-row>
        <div style="height: 20px"></div>
      </div>
    </el-dialog>
    <!-- 服务单子对话框 -->
    <el-dialog :visible.sync="ordersShow" v-if="ordersShow" width="900px"
               :show-close="true" :close-on-click-modal="true" append-to-body center class="all-open">
      <div class="title-top-alarm">
        <div><strong>服务单列表 — {{ currentSppRow.person_name }}</strong></div>
        <div class="line-title"></div>
      </div>
      <service-package-orders :spp-row="currentSppRow" :package-row="packageRow"></service-package-orders>
    </el-dialog>
  </div>
</template>

<script>
import {
  querypersonservicepackageperson,
  addpersonservicepackageperson,
  removepersonservicepackageperson,
  renewpersonservicepackageperson
} from '../../../api/serviceMark'
import { searcholdperson, queryoldpersonbyoids } from '../../../api/serviceObject'
import { queryorg } from '../../../api/organizer'
import servicePackageOrders from './servicePackageOrders.vue'

export default {
  name: 'servicePackagePersons',
  components: { servicePackageOrders },
  model: {
    prop: 'personsShow',
    event: 'change'
  },
  props: {
    packageRow: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCells: 0,
      addPersonShow: false,
      personSearch: '',
      orgSearchId: null,
      orgTree: [],
      orgCascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'child',
        emitPath: false
      },
      personResults: [],
      searchLoading: false,
      selectedPersons: [],
      addForm: {
        sp_id: 0,
        pids: [],
        start_date: ''
      },
      renewShow: false,
      renewRow: {},
      renewDate: '',
      ordersShow: false,
      currentSppRow: {}
    }
  },
  created () {
    this.addForm.sp_id = this.packageRow.id
    this.loadPersons()
    this.loadOrgTree()
  },
  methods: {
    loadPersons () {
      this.loading = true
      let params = { page: this.currentPage, size: this.pageSize }
      let data = { sp_id: this.packageRow.id }
      querypersonservicepackageperson(params, data).then(res => {
        this.tableData = res.data.list || []
        this.totalCells = res.data.cnt || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.loadPersons()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadPersons()
    },
    openAddPersons () {
      this.personSearch = ''
      this.orgSearchId = null
      this.personResults = []
      this.selectedPersons = []
      this.addForm.pids = []
      this.addForm.start_date = ''
      this.addPersonShow = true
    },
    loadOrgTree () {
      queryorg().then(res => {
        const arr = (res.data.org || []).filter(o => o.org_type === 0)
        const minLevel = arr.reduce((min, o) => Math.min(min, o.level), 100)
        const roots = arr.filter(o => o.level === minLevel)
        roots.forEach(root => {
          const children = this.arrayToOrgNode(arr, root.id)
          if (children.length) root.child = children
        })
        this.orgTree = roots
      }).catch(() => {})
    },
    arrayToOrgNode (arr, pid) {
      return arr.filter(o => o.orgpid === pid).map(o => {
        const children = this.arrayToOrgNode(arr, o.id)
        if (children.length) o.child = children
        return o
      })
    },
    searchPersonsByOrg (oid) {
      if (!oid) {
        this.personResults = []
        return
      }
      this.personSearch = ''
      this.searchLoading = true
      queryoldpersonbyoids({ oids: [oid], page: 1, size: 100 }).then(res => {
        this.personResults = res.data.persons || []
        if (this.personResults.length === 0) {
          this.$message({ message: '该组织下暂无老人', type: 'info' })
        }
        this.searchLoading = false
      }).catch(() => { this.searchLoading = false })
    },
    searchPersons () {
      if (!this.personSearch.trim()) {
        this.$message({ message: '请输入姓名进行搜索', type: 'warning' })
        return
      }
      this.orgSearchId = null
      this.searchLoading = true
      searcholdperson({ lessname: this.personSearch, page: 1, size: 20 }).then(res => {
        this.personResults = res.data.persons || []
        if (this.personResults.length === 0) {
          this.$message({ message: '未找到匹配老人', type: 'info' })
        }
        this.searchLoading = false
      }).catch(() => { this.searchLoading = false })
    },
    addPersonToList (person) {
      if (!this.isPersonAdded(person)) {
        this.addForm.pids.push(person.id)
        this.selectedPersons.push(person)
      }
    },
    selectAllPersons () {
      this.personResults.forEach(p => {
        if (!this.isPersonAdded(p)) {
          this.addForm.pids.push(p.id)
          this.selectedPersons.push(p)
        }
      })
    },
    clearAllPersons () {
      // 只取消选中列表里来自当前搜索结果的人员
      const resultIds = this.personResults.map(p => p.id)
      this.addForm.pids = this.addForm.pids.filter(id => !resultIds.includes(id))
      this.selectedPersons = this.selectedPersons.filter(p => !resultIds.includes(p.id))
    },
    removeFromSelected (idx) {
      this.addForm.pids.splice(idx, 1)
      this.selectedPersons.splice(idx, 1)
    },
    isPersonAdded (person) {
      return this.addForm.pids.indexOf(person.id) > -1
    },
    submitAddPersons () {
      if (this.addForm.pids.length === 0) {
        this.$message({ message: '请至少选择一位老人', type: 'warning' })
        return
      }
      let data = {
        sp_id: this.addForm.sp_id,
        pids: this.addForm.pids,
        start_date: this.addForm.start_date || ''
      }
      addpersonservicepackageperson(data).then(() => {
        this.$notify({ title: '成功', message: '添加老人成功', type: 'success', duration: 2000 })
        this.addPersonShow = false
        this.loadPersons()
      }).catch(() => {})
    },
    removePersonRow (row) {
      this.$confirm(`确定要将【${row.person_name}】从此服务包移除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removepersonservicepackageperson({ ids: [row.id] }).then(() => {
          this.$notify({ title: '成功', message: '移除成功', type: 'success', duration: 2000 })
          this.loadPersons()
        }).catch(() => {})
      }).catch(() => {})
    },
    openRenew (row) {
      this.renewRow = row
      this.renewDate = ''
      this.renewShow = true
    },
    viewOrders (row) {
      this.currentSppRow = row
      this.ordersShow = true
    },
    getProgressPct (row) {
      if (!row.total_count || row.total_count === 0) return 0
      return Math.min(100, Math.round((row.generated_count / row.total_count) * 100))
    },
    submitRenew () {
      let data = {
        spp_id: this.renewRow.id,
        new_start_date: this.renewDate || ''
      }
      renewpersonservicepackageperson(data).then(() => {
        this.$notify({ title: '成功', message: '续期成功', type: 'success', duration: 2000 })
        this.renewShow = false
        this.loadPersons()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/servicePackagePersons.vue